import { render, staticRenderFns } from "./WechatDevice.vue?vue&type=template&id=cc5467ba&scoped=true"
import script from "./WechatDevice.vue?vue&type=script&lang=js"
export * from "./WechatDevice.vue?vue&type=script&lang=js"
import style0 from "./WechatDevice.vue?vue&type=style&index=0&id=cc5467ba&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5467ba",
  null
  
)

export default component.exports